/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apple_IdInputs */

const en_apple_id = /** @type {(inputs: Apple_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apple ID`)
};

const ar_apple_id = /** @type {(inputs: Apple_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معرف ابل`)
};

const de_apple_id = /** @type {(inputs: Apple_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apple-ID`)
};

const es_apple_id = /** @type {(inputs: Apple_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID de Apple`)
};

const fr_apple_id = /** @type {(inputs: Apple_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identifiant Apple`)
};

const it_apple_id = /** @type {(inputs: Apple_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apple ID`)
};

const ja_apple_id = /** @type {(inputs: Apple_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apple ID`)
};

const ko_apple_id = /** @type {(inputs: Apple_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apple ID`)
};

const pt_br_apple_id = /** @type {(inputs: Apple_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apple ID`)
};

const ru_apple_id = /** @type {(inputs: Apple_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apple ID`)
};

const th_apple_id = /** @type {(inputs: Apple_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apple ID`)
};

const tr_apple_id = /** @type {(inputs: Apple_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apple ID`)
};

const zh_cn_apple_id = /** @type {(inputs: Apple_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apple ID`)
};

const zh_tw_apple_id = /** @type {(inputs: Apple_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apple ID`)
};

/**
* | output |
* | --- |
* | "Apple ID" |
*
* @param {Apple_IdInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const apple_id = /** @type {((inputs?: Apple_IdInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apple_IdInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_apple_id(inputs)
	if (locale === "ar") return ar_apple_id(inputs)
	if (locale === "de") return de_apple_id(inputs)
	if (locale === "es") return es_apple_id(inputs)
	if (locale === "fr") return fr_apple_id(inputs)
	if (locale === "it") return it_apple_id(inputs)
	if (locale === "ja") return ja_apple_id(inputs)
	if (locale === "ko") return ko_apple_id(inputs)
	if (locale === "pt_br") return pt_br_apple_id(inputs)
	if (locale === "ru") return ru_apple_id(inputs)
	if (locale === "th") return th_apple_id(inputs)
	if (locale === "tr") return tr_apple_id(inputs)
	if (locale === "zh_cn") return zh_cn_apple_id(inputs)
	return zh_tw_apple_id(inputs)
});